import { V2MachineryComplianceSection } from '../../components/V2MachineryComplianceSection'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductMachineryRegulationPageProps = {
  productId: string
}

export function V2ProductMachineryRegulationPage({
  productId,
}: V2ProductMachineryRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law="machinery">
      {(machineryApplies) => (
        <V2MachineryComplianceSection
          productId={productId}
          machineryApplies={machineryApplies}
          embedded
        />
      )}
    </V2ProductRegulationPageShell>
  )
}
